import OtherSellers from './other-sellers';

export default OtherSellers;
